module.exports = __webpack_public_path__ + "img/3.fbe37cac.jpg";